import omegaMotif from "../assets/omega-scroll-motif.webp";

export function AmbientBackground() {
  return (
    <div className="ambient-background" aria-hidden="true">
      <img className="ambient-background__omega" src={omegaMotif} alt="" />
    </div>
  );
}
